import { Link, useLocation, useNavigate } from "react-router-dom";
import { CallToAction } from "./components";
import { CustomButton, Header } from "../../components";
import "./SingleProject.css";
import { useEffect, useState } from "react";
import ReactCardFlip from "react-card-flip";

const SingleProject = () => {
    const { state } = useLocation();
    const project = state.project;
    const navigate = useNavigate();
    const [isFlipped, setIsFlipped] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setIsFlipped(!isFlipped);
        }, 1000);
    }, []);

    console.log("PROJECT: ", project);
    return (
        <div className="project-container">
            <Header
                CallToAction={<CallToAction />}
                title={project.project_title}
                GoBackClick={() => navigate("/catalog")}
            />
            <div className="project">
                <div className="project-content">
                    <p className="text-content">
                        {project.project_description}
                    </p>
                    {project.project_link && (
                        <div
                            className="project-button"
                            onClick={() =>
                                window.open(`${project.project_link}`, "_blank")
                            }
                        >
                            <CustomButton
                                content={`See the real thing!`}
                                direction={"right"}
                                size={"18px"}
                                weight={"300"}
                                borderBottom
                                light
                            />
                        </div>
                    )}
                </div>

                <div className="img-container">
                    <ReactCardFlip
                        isFlipped={isFlipped}
                        flipDirection="horizontal"
                        flipSpeedFrontToBack={1}
                        flipSpeedBackToFront={1}
                    >
                        <div onClick={() => setIsFlipped(!isFlipped)}>
                            {project.featured_image && (
                                <img src={project.featured_image} alt="" />
                            )}
                        </div>

                        <div onClick={() => setIsFlipped(!isFlipped)}>
                            {project.imageUrl ? (
                                <img src={project.imageUrl} alt="" />
                            ) : (
                                <img src={project.featured_image} alt="" />
                            )}
                        </div>
                    </ReactCardFlip>
                </div>
                <div className="categories-container">
                    <h4>Categories</h4>
                    <div className="categories">
                        {project.categories.map((cat, i) => (
                            <Link
                                to={"/catalog"}
                                state={{ selectedCategories: [cat.id] }}
                                key={i}
                            >
                                <div className="category">{cat.name}</div>
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SingleProject;
